import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';

export default class extends Controller {
    static targets = ["container"]

    connect() {
        console.log("Swiper controller connected")
        if (!this.element) return

        this.swiper = new Swiper(this.element, {
            slidesPerView: 1.2,
            spaceBetween: 10,
            centeredSlides: false,
            grabCursor: true,
            freeMode: true,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
                releaseOnEdges: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3.2,
                    spaceBetween: 30,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    disconnect() {
        if (this.swiper) {
            this.swiper.destroy()
        }
    }
}
